/**
 * Canonical text-normalization for composition phrase translation lookups
 * (PLAT-9870 / PLAT-9964 / PLAT-9967).
 *
 * Trim leading/trailing whitespace, collapse runs of internal whitespace to
 * a single space, lowercase. Used as the lookup key for every read/write to
 * `TranslationData.compositionPhrases[]` and as the dedupe key for the
 * `compositionTargets[]` payload sent to the backend.
 *
 * The stored `sourceText` preserves the original casing and whitespace for
 * display; matching uses the normalized form. This makes `"  Hello   World "`
 * and `"hello world"` share a translation.
 *
 * This implementation is a verbatim port of the backend's
 * `lib/translation/compositions/normalizePhrase.ts` in arbor-v1. The two
 * MUST stay character-for-character identical so the plugin's dedupe and
 * the backend's dedupe land on the same keys — any change here requires a
 * matching change on arbor-v1 and vice versa.
 */
export function normalizePhrase(s: string): string {
  return s.trim().replace(/\s+/g, ' ').toLowerCase();
}
